"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRow = exports.StyledRow = void 0;
var react_1 = __importDefault(require("react"));
var Label_1 = require("./Label");
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
var HelpTooltip_1 = require("./HelpTooltip");
exports.StyledRow = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  width: 100%;\n  grid-template-columns: 40% 60%;\n  grid-gap: ", "px;\n  align-items: center;\n"], ["\n  display: grid;\n  width: 100%;\n  grid-template-columns: 40% 60%;\n  grid-gap: ", "px;\n  align-items: center;\n"])), accessors_1.space('sm'));
var ErrorWrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-column: 2 / -1;\n  padding: 0 ", "px;\n  font-family: ", ";\n  font-size: ", "px;\n  color: tomato;\n"], ["\n  grid-column: 2 / -1;\n  padding: 0 ", "px;\n  font-family: ", ";\n  font-size: ", "px;\n  color: tomato;\n"])), accessors_1.space('sm'), accessors_1.fontFamily('sansSerif'), accessors_1.fontSize('label'));
var LabelWithTooltip = styled_components_1.default('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n"], ["\n    display: flex;\n    align-items: center;\n"])));
var InputRow = function (_a) {
    var renderInput = _a.renderInput, label = _a.label, required = _a.required, tooltip = _a.tooltip, error = _a.error;
    return (react_1.default.createElement(exports.StyledRow, null,
        react_1.default.createElement(LabelWithTooltip, null,
            react_1.default.createElement(Label_1.Label, { label: "" + label + (required ? ' *' : '') }),
            !!tooltip && (react_1.default.createElement(react_1.default.Fragment, null,
                "\u00A0",
                react_1.default.createElement(HelpTooltip_1.HelpTooltip, { text: tooltip })))),
        renderInput(),
        !!error &&
            react_1.default.createElement(ErrorWrapper, null, error)));
};
exports.InputRow = InputRow;
exports.default = exports.InputRow;
var templateObject_1, templateObject_2, templateObject_3;
